import { useMemo } from 'react';
import { EEthereumNetworkId } from '@ankr.com/provider';

import { useGetChainIdQuery } from 'modules/store';

import { useChainList, UseChainListItem } from './useChainList';

export function useChainData(
  chainId?: EEthereumNetworkId | null,
): UseChainListItem | null {
  const { data: currentChainId } = useGetChainIdQuery();
  const chains = useChainList();

  return useMemo(() => {
    const id = chainId || currentChainId;
    const data = chains.find(item => item.chainId === id);
    if (!data) {
      return null;
    }

    return data;
  }, [chainId, chains, currentChainId]);
}
